import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import companyInfo from '../../../themes/themes';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: `0fr repeat(0, [col] 1fr) 0fr`,
    gridTemplateRows: `repeat(5, [row] 0fr)`,
    gridRowGap: theme.spacing(2),
    backgroundColor: 'white',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow:
      '0px 8px 28px -6px rgba(31, 75, 75, 0.12), 0px 18px 88px -4px rgba(31, 75, 75, 0.14)',
  },
  header: {
    textAlignLast: 'center',
    fontWeight: 600,
  },
  answerColumn: {
    borderRadius: '8px 10px 8px 10px',
    gridColumn: 1,
    minWidth: 200,
  },
  icon: {
    width: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
}));

interface IAnswerWith8Fig {
  netCapital: string;
  netCapitalMin: number;
  netCapitalMax: number;
  time: string;
}
export default function AnswerWith8Fig({
  netCapital,
  netCapitalMin,
  netCapitalMax,
  time,
}: IAnswerWith8Fig) {
  const classes = useStyles();
  const theme = process.env.REACT_APP_THEME;

  const answers = [
    { text: `With ${companyInfo[theme].company}`, img: false, header: true },
    { text: `${netCapital}`, img: true, header: false },
    {
      text: `$${(netCapitalMin * 0.06) | 0} - $${(netCapitalMax * 0.1) | 0}`,
      img: true,
      header: false,
    },
    { text: `7-20%`, img: true, header: false },
    { text: `${time} months`, img: true, header: false },
  ];

  return (
    <div className={classes.container}>
      {answers.map((answer, id) => (
        <Typography
          key={id}
          variant={'subtitle2'}
          className={
            classes.answerColumn + ' ' + (answer.header && classes.header)
          }
          style={{ gridRow: id + 1 }}
        >
          {answer.img && (
            <img
              src={`./icons/vShape.svg`}
              alt={'vShape'}
              className={classes.icon}
            />
          )}
          {answer.text}
        </Typography>
      ))}
    </div>
  );
}
